import { SET_TOOLBAR_BUTTON_LIST_WIDTH } from './types';
import { getButtonListWidth } from '../../client/utils/clientInspectionUtils';

export default function setButtonListWidth() {
  return {
    type: SET_TOOLBAR_BUTTON_LIST_WIDTH,
    payload: getButtonListWidth(),
  };
}
